export function date_now() {
  return Date.now();
}
